<template>
  <div class="service-item">
    <div class="row">
      <div class="col-lg-6 d-none d-lg-block" v-if="index % 2 == 0">
        <div class="service-item__image">
          <img :src="item.image" />
        </div>
      </div>
      <div class="col-lg-6">
        <div
          class="service-item__content team-item"
          :class="[
            { 'service-item__content--right team-item--dark': index % 2 == 0 },
            item.iconColor ? 'service-item__content--custom-color' : ''
          ]"
          :style="item.iconColor ? { '--icon-color': item.iconColor } : null"
        >
          <div class='team-item__inner h-100 pt-10'>
            <div class="service-item__icon">
              <div v-if="item.svgCode" v-html="item.svgCode" class="service-item__svg"></div>
              <img v-else-if="item.iconUrl" :src="item.iconUrl" :alt="item.title || ''" />
              <img v-else :src="fallbackIcons[index % fallbackIcons.length]" :alt="item.title || ''" />
            </div>
            <div class="service-item__title">
              {{ item.title }}
            </div>
            <div class="service-item__text" v-html="item.description"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 d-none d-lg-block" v-if="index % 2 != 0">
        <div class="service-item__image">
          <img :src="item.image" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      fallbackIcons: [
        require("@/assets/images/icons/cube.svg"),
        require("@/assets/images/icons/way.svg"),
        require("@/assets/images/icons/contract.svg"),
        require("@/assets/images/icons/trust.jpeg"),
      ],
    };
  },
};
</script>
<style scoped>
.service-item__svg { display: inline-block; }
.service-item__svg >>> svg { width: 100px; height: 100px; object-fit: contain; }
.service-item__content--custom-color >>> .service-item__svg svg,
.service-item__content--custom-color >>> .service-item__svg svg path { fill: var(--icon-color) !important; }
</style>
